<template>
  <div class="animated fadeIn pb-8 add-product">
    <div>
      <v-card class="common-card">
        <div>
          <h4 class="c-grey">افزودن محصول جدید</h4>
        </div>
        <hr class="mt-5" />

        <v-row>
          <v-col cols="12">
            <div class="d-flex align-items-end mb-6">
              <div
                class="img-box pointer"
                @click="$refs.productImage.$refs.input.click()"
              >
                <img
                  height="150"
                  width="150"
                  class="img"
                  :src="
                    newItem.pictureId ? newItem.pictureUrl : '/no-image.png'
                  "
                />
                <v-icon x-large class="img-icon white--text">mdi-camera</v-icon>
                <div class="img-loading" v-if="mainImageLoading">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                    :size="40"
                  ></v-progress-circular>
                  <h6 class="mt-4 grey--text text--darken-4">
                    در حال بارگذاری...
                  </h6>
                </div>
              </div>
              <v-btn
                class="orange-mainBtn pa-5 ms-sm-4 ms-1"
                @click="$refs.productImage.$refs.input.click()"
              >
                <v-icon class="me-2">mdi-camera-outline</v-icon>
                بارگذاری تصویر برگزیده
              </v-btn>
              <v-file-input
                v-show="false"
                @change="newProductMainImageUpload(mainImage)"
                v-model="mainImage"
                ref="productImage"
              ></v-file-input>
            </div>
          </v-col>
          <v-col md="4" sm="6" xs="12" cols="12">
            <label class="primary--text font-weight-bold"
              ><span class="red--text">*</span> نام محصول:</label
            >
            <v-text-field
              placeholder="نام محصول"
              outlined
              dense
              hide-details
              v-model="newItem.name"
              :disabled="role == 'sales'"
            ></v-text-field>
          </v-col>
          <v-col md="4" sm="6" xs="12" cols="12">
            <label class="primary--text font-weight-bold"> زیرعنوان: </label>
            <v-text-field
              placeholder="زیر عنوان"
              outlined
              dense
              hide-details
              v-model="newItem.subTitle"
            ></v-text-field>
          </v-col>
          <v-col md="4" sm="6" xs="12" cols="12">
            <label class="primary--text font-weight-bold"> موضوع:</label>
            <v-text-field
              placeholder="موضوع"
              outlined
              dense
              hide-details
              v-model="newItem.subject"
            ></v-text-field>
          </v-col>
          <v-col md="4" sm="6" xs="12" cols="12">
            <label class="primary--text font-weight-bold">
              <span> قیمت: </span>
            </label>
            <v-text-field
              v-model.number="newItem.price"
              density="compact"
              outlined
              dense
              variant="solo"
              class="input_panel_product"
              type="number"
              placeholder=" قیمت"
            ></v-text-field>
          </v-col>
          <v-col md="4" sm="6" xs="12" cols="12">
            <label class="primary--text font-weight-bold">
              <span> شابک: </span>
            </label>
            <v-text-field
              v-model.number="newItem.isbn"
              density="compact"
              outlined
              dense
              variant="solo"
              class="input_panel_product"
              type="text"
              placeholder=" شابک"
            ></v-text-field>
          </v-col>
          <v-col md="4" sm="6" xs="12" cols="12">
            <label class="primary--text font-weight-bold">
              <span> سال انتشار: </span>
            </label>
            <v-text-field
              v-model.number="newItem.publishYear"
              density="compact"
              outlined
              dense
              variant="solo"
              class="input_panel_product"
              type="number"
              placeholder="سال انتشار"
            ></v-text-field>
          </v-col>
          <v-col md="4" sm="6" xs="12" cols="12">
            <label class="primary--text font-weight-bold">
              <span> انتشارات: </span>
            </label>
            <v-select
              :items="publishers"
              v-model="newItem.publisherId"
              density="compact"
              outlined
              dense
              variant="solo"
              class="input_edit_list"
              append-inner-icon="mdi-menu-down"
              item-value="id"
              item-text="name"
              @change="divisionsList"
              placeholder="انتشارات"
            >
            </v-select>
          </v-col>
          <v-col md="4" sm="6" xs="12" cols="12">
            <label class="primary--text font-weight-bold">
              <span> پایه تحصیلی: </span>
            </label>
            <v-select
              :items="educationalStage"
              v-model="newItem.educationalStage"
              density="compact"
              outlined
              dense
              variant="solo"
              class="input_edit_list"
              append-inner-icon="mdi-menu-down"
              item-value="key"
              item-text="text"
              placeholder="پایه تحصیلی"
            >
            </v-select>
          </v-col>
          <v-col md="4" sm="6" xs="12" cols="12">
            <label class="primary--text font-weight-bold">
              <span> مقطع تحصیلی: </span>
            </label>
            <v-select
              :items="educationalGrade"
              v-model="newItem.educationalGrade"
              density="compact"
              outlined
              dense
              variant="solo"
              class="input_edit_list"
              append-inner-icon="mdi-menu-down"
              item-value="key"
              item-text="text"
              placeholder="مقطع تحصیلی"
            >
            </v-select>
          </v-col>
          <v-col md="4" sm="6" xs="12" cols="12">
            <label class="primary--text font-weight-bold">
              <span> رشته تحصیلی: </span>
            </label>
            <v-select
              :items="major"
              v-model="newItem.major"
              density="compact"
              outlined
              dense
              variant="solo"
              class="input_edit_list"
              append-inner-icon="mdi-menu-down"
              item-value="key"
              item-text="text"
              placeholder="رشته تحصیلی"
            >
            </v-select>
          </v-col>
          <v-col md="4" sm="6" xs="12" cols="12">
            <label class="primary--text font-weight-bold">
              <span> سری: </span>
            </label>
            <v-select
              :disabled="!newItem.publisherId"
              :items="divisions"
              v-model="newItem.divisionId"
              density="compact"
              outlined
              dense
              variant="solo"
              class="input_edit_list"
              append-inner-icon="mdi-menu-down"
              item-value="id"
              item-text="name"
              placeholder="سری"
            >
            </v-select>
          </v-col>
          <v-col md="4" sm="6" xs="12" cols="12">
            <label class="primary--text font-weight-bold">
              <span> مخصوص کنکور: </span>
            </label>
            <v-select
              :items="entranceExam"
              v-model="newItem.entranceExam"
              density="compact"
              outlined
              dense
              variant="solo"
              class="input_edit_list"
              append-inner-icon="mdi-menu-down"
              item-value="key"
              item-text="text"
              placeholder="مخصوص کنکور "
            >
            </v-select>
          </v-col>
          <v-col md="4" sm="6" xs="12" cols="12">
            <label class="primary--text font-weight-bold">
              <span> رشته کنکور: </span>
            </label>
            <v-select
              :items="entranceExamMajor"
              v-model="newItem.entranceExamMajor"
              density="compact"
              outlined
              dense
              variant="solo"
              class="input_edit_list"
              append-inner-icon="mdi-menu-down"
              item-value="key"
              item-text="text"
              placeholder="رشته کنکور "
            >
            </v-select>
          </v-col>
          <v-col md="4" sm="6" xs="12" cols="12">
            <label class="primary--text font-weight-bold">
              <span> نوع کتاب: </span>
            </label>
            <v-select
              :items="generalSubject"
              v-model="newItem.generalSubject"
              density="compact"
              outlined
              dense
              variant="solo"
              class="input_edit_list"
              append-inner-icon="mdi-menu-down"
              item-value="key"
              item-text="text"
              placeholder="نوع کتاب "
            >
            </v-select>
          </v-col>
          <v-col md="4" sm="6" xs="12" cols="12">
            <label class="primary--text font-weight-bold">
              <span> نویسندگان: </span>
            </label>
            <v-autocomplete
              :items="authors"
              v-model="newItem.authorsId"
              density="compact"
              outlined
              dense
              multiple
              variant="solo"
              class="input_edit_list"
              append-inner-icon="mdi-menu-down"
              item-value="id"
              item-text="name"
              chips
              color="primary"
              placeholder="نویسندگان "
            >
              <template #selection="{ item }">
                <v-chip small color="primary">{{ item.name }}</v-chip>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col md="4" sm="6" xs="12" cols="12">
            <label class="primary--text font-weight-bold"
              >برچسب‌های محصول:</label
            >
            <div class="d-flex flex-row">
              <v-text-field
                outlined
                dense
                height="40"
                hide-details
                v-model="newTag"
                @keyup.enter="newTag ? addNewTag('newItem') : ''"
                >''
                <template slot="label">
                  <div style="font-size: 14px">برچسب‌ جدید</div>
                </template>
              </v-text-field>
              <v-btn
                class="ms-2 green-mainBtn"
                width="60"
                min-width="40"
                height="40"
                :disabled="!newTag"
                @click="addNewTag('newItem')"
                >ثبت
              </v-btn>
            </div>
            <div v-if="newItem.tags">
              <v-row v-if="newItem.tags.length">
                <v-col class="d-flex flex-wrap">
                  <div
                    class="orange-badge me-2 mt-2"
                    v-for="(item, index) in newItem.tags"
                    :key="index"
                  >
                    <span class="mt-2">{{ item }}</span>
                    <span
                      ><v-icon
                        @click="removeTag('newItem', index)"
                        color="primary"
                        small
                        class="ps-1"
                        >mdi-close</v-icon
                      ></span
                    >
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-col>
          <v-col md="4" sm="6" xs="12" cols="12">
            <label class="primary--text font-weight-bold">
              <span> لینک ویدیو آپارات: </span>
            </label>
            <v-text-field
              v-model.number="newItem.aparatLink"
              outlined
              dense
              variant="solo"
              class="input_panel_product"
              :rules="linkRules"
              placeholder="لینک ویدیو آپارات"
            ></v-text-field>
          </v-col>
          <v-col md="4" sm="6" xs="12" cols="12">
            <label class="primary--text font-weight-bold">
              <span> موجودی اولیه: </span>
            </label>
            <v-text-field
              v-model.number="newItem.amount"
              density="compact"
              outlined
              dense
              variant="solo"
              class="input_panel_product"
              type="number"
              placeholder="موجودی اولیه"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <label class="primary--text font-weight-bold">
              <span> توضیحات محصول: </span>
            </label>
            <v-textarea
              outlined
              dense
              v-model="newItem.onlineShopDescription"
              placeholder="توضیحات محصول"
            >
            </v-textarea>
          </v-col>
        </v-row>

        <div class="d-flex flex-sm-row justify-end text-left pb-3 px-4 mt-4">
          <v-btn
            @click="addItem()"
            :disabled="!newItem.name"
            class="green-mainBtn white--text"
            width="90"
          >
            افزودن
          </v-btn>
          <v-btn
            class="red-mainBtn white--text ms-2"
            @click="cancelAdd()"
            width="90"
          >
            لغو
          </v-btn>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import MyCalendar from "../../components/MyCalendar.vue";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import { AtomSpinner } from "epic-spinners";
import Var from "../../../variables";
import VueCkeditor from "vue-ckeditor2";

export default {
  components: {
    VueCkeditor,
    AtomSpinner,
    MyCalendar,
    datePicker: VuePersianDatetimePicker,
  },
  data() {
    return {
      type: Var.allTypes[3],
      variants: [],
      publishers: [],
      mainVariantSelected: false,
      config: {
        toolbar: [
          [
            "Bold",
            "Italic",
            "Underline",
            "Strike",
            "JustifyLeft",
            "JustifyCenter",
            "JustifyRight",
            "Font",
            "FontSize",
          ],
        ],
      },
      busy: false,
      loading: false,
      colorMenu: false,
      editColorMenu: false,
      headers: [
        { value: "mainVariant", text: "تنوع اصلی", sortable: false },
        { value: "barcode", text: "بارکد ", sortable: false },
        { value: "expireDate", text: " تاریخ انقضا", sortable: false },
        { value: "color", text: "رنگ", sortable: false },
        { value: "size", text: "سایز", sortable: false },
        { value: "volume", text: "حجم", sortable: false },
        { value: "dimension", text: "ابعاد", sortable: false },
        { value: "weight", text: "وزن", sortable: false },
        { value: "producingCountry", text: "کشور تولیدکننده", sortable: false },
        { value: "productionYear", text: "سال تولید", sortable: false },
        { value: "contents", text: "ترکیبات ", sortable: false },
        { value: "sum", text: " موجودی ", sortable: false },
        { value: "price", text: " قیمت فروش (تومان)", sortable: false },
        // { value: "discountedPrice", text: " قیمت در تخفیف (تومان)", sortable: false },
        { value: "operation", text: " عملیات ", sortable: false },
      ],
      openEditDialog: false,
      selectedVariety: {},

      selectedIndex: "",
      newItem: {
        tags: [],
      },
      mainImageLoading: false,
      role: "",
      roleName: "",
      addVarietyDialog: false,
      newVariety: {
        colorCode: "#bf0000",
        mainVariant: false,
      },
      mainImage: [],
      myMainImage: new Object({
        uploadPercentage: 0,
      }),
      editMainImage: [],
      editMyMainImage: new Object({
        uploadPercentage: 0,
      }),
      editMainImageLoading: false,
      categories: [],
      divisions: [],
      authors: [],
      brands: [],
      educationalStage: [
        { key: "first", text: "اول" },
        { key: "second", text: "دوم" },
        { key: "third", text: "سوم" },
        { key: "fourth", text: "چهارم" },
        { key: "fifth", text: "پنجم" },
        { key: "sixth", text: "ششم" },
        { key: "seventh", text: "هفتم" },
        { key: "eighth", text: "هشتم" },
        { key: "ninth", text: "نهم" },
        { key: "tenth", text: "دهم" },
        { key: "eleventh", text: "یازدهم" },
        { key: "twelfth", text: "دوازدهم" },
      ],
      educationalGrade: [
        { key: "preSchool", text: "پیش دبستانی" },
        { key: "elementarySchool", text: "ابتدایی" },
        { key: "middleSchool", text: "متوسطه اول" },
        { key: "highSchool", text: "متوسطه دوم" },
      ],
      major: [
        { key: "mathematic", text: "ریاضی و فیزیک" },
        { key: "science", text: "علوم تجربی" },
        { key: "humanities", text: "علوم انسانی" },
      ],
      entranceExam: [
        { key: "true", text: "بله" },
        { key: "false", text: "خیر" },
      ],
      entranceExamMajor: [
        { key: "mathematic", text: "ریاضی و فیزیک" },
        { key: "science", text: "علوم تجربی" },
        { key: "humanities", text: "علوم انسانی" },
        { key: "art", text: "هنر" },
        { key: "vocational", text: "فنی و حرفه‌ای" },
        { key: "foreignLanguages", text: "زبان‌های خارجی" },
        { key: "allMajors", text: "عمومی" },
      ],
      generalSubject: [
        { key: "general", text: "جامع" },
        { key: "review", text: "جمع‌بندی" },
        { key: "stepbystep", text: "مبحثی" },
      ],
      selectedRow: {},
      reactivity: false,
      updating: false,
      newTag: "",
      perPage: 5,
      currentPage: 1,
      perPageItems: [5, 10, 20],
      editNewTag: "",
      properties: [],
      property: {},
      galleryImage: [],
      myFile: new Object({
        uploadPercentage: 0,
      }),
    };
  },
  methods: {
    getProperties() {
      this.gettingData = true;
      Axios.get(this.baseUrl + "/satrapp/properties/list", {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("token"),
        },
      })

        .then((res) => {
          if (res.status == 200) {
            this.properties = res.data;

            this.properties.forEach((element) => {
              if (element.type == "string" || element.type == "select") {
                this.property[element.fieldName] = "";
              } else if (element.type == "number") {
                this.property[element.fieldName] = null;
              } else if (element.type == "boolean") {
                this.property[element.fieldName] = false;
              }
            });
            this.gettingData = false;
          }
        })
        .catch((err) => {
          this.gettingData = false;
          console.log(err);
          this.toast.error(err.response.data);
        });
    },
    addVariety() {
      this.newVariety = { colorCode: "#bf0000", mainVariant: false };
      this.addVarietyDialog = true;
    },
    removeTag(dataName, index) {
      this[dataName].tags.splice(index, 1);
      this.reactivity = !this.reactivity;
    },
    editDialog(item, index) {
      this.selectedVariety = JSON.parse(JSON.stringify(item));
      this.selectedVariety.colorCode = item.colorCode
        ? JSON.parse(JSON.stringify(item.colorCode))
        : "#bf0000";
      this.selectedIndex = index;
      this.openEditDialog = true;
    },
    editVariant() {
      this.updating = true;
      this.variants[this.selectedIndex] = this.selectedVariety;
      this.openEditDialog = false;
      this.reactivity = !this.reactivity;
      setTimeout(() => {
        this.updating = false;
      }, 100);
    },
    selectMainVariant(index) {
      this.variants.forEach((x) => (x.mainVariant = false));
      this.variants[index].mainVariant = true;
      this.reactivity = !this.reactivity;
      this.mainVariantSelected = true;
    },
    addNewVariety() {
      if (!this.newVariety.barcode) {
        delete this.newVariety.barcode;
      }
      this.variants.unshift(this.newVariety);
      this.addVarietyDialog = false;
    },
    cancelAdd() {
      window.close();
      this.$router.push("/shop/products");
    },
    newProductMainImageUpload(file) {
      if (!file) {
        return;
      }
      let sizeMB = file.size / 1024 / 1024;

      if (sizeMB > 5) {
        this.toast(
          "حجم فایل " + file.name + " نباید از 5 مگابایت بیشتر باشد",
          "error"
        );
        return;
      } else if (file.type != "image/jpeg" && file.type != "image/png") {
        this.toast("فرمت فایل مورد نظر مجاز نمی‌باشد.", "error");
        return;
      } else {
        // NOTE (m-myUpload) to upload files
        this.myMainImage.showProgress = true;
        this.myMainImage.variant = "info";
        this.myMainImage.uploadPercentage = 0;
        this.myMainImage.isUploaded = false;
        this.myMainImage.uploadButDisable = true;
        var formData = new FormData();
        formData.append(file.name, file);
        this.mainImageLoading = true;
        Axios.post(
          this.baseUrl + "/satrapp/warehouse/warehouseitem/upload/draft",
          formData,
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
            onUploadProgress: ((progressEvent) => {
              this.myMainImage.uploadPercentage =
                Math.round((progressEvent.loaded * 100) / progressEvent.total) -
                1;
            }).bind(this),
          }
        )
          .then((d) => {
            if (d.status == 200) {
              this.toast(d.data.message, "success");
              this.myMainImage.isUploaded = true;
              this.myMainImage.uploadPercentage = 100;
              this.myMainImage.striped = false;
              this.myMainImage.variant = "success";
              this.myMainImage.uploadButDisable = false;
              this.newItem.pictureId = d.data.id;
              this.newItem.pictureUrl = d.data.url;
              this.mainImageLoading = false;
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.mainImageLoading = false;
          });
      }
    },
    addItem() {
      this.busy = true;
      this.variants.forEach((x) => (x.price = Number(x.price)));
      this.variants.forEach((x) => (x.buyPrice = Number(x.buyPrice)));
      this.variants.forEach((x) => (x.sum = Number(x.sum)));
      let propertiesList = [];
      this.properties.forEach((element) => {
        propertiesList.push({
          id: element.id,
          value: this.property[element.fieldName],
        });
      });
      Axios.post(
        this.baseUrl + "/satrapp/warehouse/warehouseItem/new",
        {
          pictureId: this.newItem.pictureId
            ? this.newItem.pictureId
            : undefined,
          name: this.newItem.name,
          subTitle: this.newItem.subTitle,
          price: this.newItem.price,
          categoryId: this.newItem.categoryId
            ? this.newItem.categoryId
            : undefined,
          tags: this.newItem.tags,
          subject: this.newItem.subject,
          educationalStage: this.newItem.educationalStage,
          educationalGrade: this.newItem.educationalGrade,
          major: this.newItem.major,
          isbn: this.newItem.isbn,
          generalSubject: this.newItem.generalSubject,
          publishYear: this.newItem.publishYear,
          entranceExam: this.newItem.entranceExam,
          entranceExamMajor: this.newItem.entranceExamMajor,
          amount: Number(this.newItem.amount) ? Number(this.newItem.amount) : 0,
          special: false,
          publisherId: this.newItem.publisherId
            ? this.newItem.publisherId
            : undefined,
          authorsId: this.newItem.authorsId
            ? this.newItem.authorsId
            : undefined,
          divisionId: this.newItem.divisionId
            ? this.newItem.divisionId
            : undefined,
          onlineShopDescription: this.newItem.onlineShopDescription,
          properties: propertiesList,
          aparatLink: this.newItem.aparatLink,
          warehouseTypeId: this.type.id ? this.type.id : undefined,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data, "success");
            // this.newItem = { tags: [] };
            this.busy = false;
            // window.close();
            this.$router.back();
            // window.reload();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.busy = false;
            // this.$router.push("products");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.busy = false;
          // this.$router.push("products");
        });
    },
    getCategories() {
      Axios.get(this.baseUrl + "/satrapp/shop/categories/list", {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("token"),
        },
      })
        .then((res) => {
          if (res.status == 200) {
            this.categories = res.data;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    addNewTag(dataName) {
      if (dataName == "newItem") {
        if (!this.newItem.tags.includes(this.newTag.trim())) {
          this.newItem.tags.push(this.newTag.trim());
          this.newTag = "";
        } else {
          this.$toast("این تگ پیش از این افزوده شده است.", "error");
        }
      }
    },
    pulishersList() {
      Axios.get(this.baseUrl + "/satrapp/publishers/list", {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("token"),
        },
      })

        .then((res) => {
          if (res.status == 200) {
            this.publishers = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast.error(err.response.data);
        });
    },
    divisionsList() {
      Axios.get(
        this.baseUrl + "/satrapp/divisions/list/" + this.newItem.publisherId,
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )

        .then((res) => {
          if (res.status == 200) {
            this.divisions = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast.error(err.response.data);
        });
    },
    authorsList() {
      Axios.get(this.baseUrl + "/satrapp/authors/list", {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("token"),
        },
      })

        .then((res) => {
          if (res.status == 200) {
            this.authors = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
  },
  mounted() {
    this.getProperties();
    this.pulishersList();
    this.authorsList();
    this.newItem.entranceExam = this.entranceExam[1].key;
    this.getCategories();
  },
  computed: {
    linkRules() {
      return [
        (v) => !!v || "لینک الزامی است",
        (v) => /^(ftp|http|https):\/\/[^ "]+$/.test(v) || "لینک معتبر نیست",
      ];
    },
    computedAddVarietyDis() {
      if (
        this.newVariety.price &&
        this.newVariety.buyPrice &&
        this.newVariety.sum
      ) {
        return false;
      }
      return true;
    },
    computedVariant() {
      if (
        this.newItem.name &&
        this.newItem.categoryId &&
        this.newItem.tags.length &&
        this.newItem.publisherId
      ) {
        return false;
      } else return true;
    },
    computedNewBtn() {
      if (this.newItem.name) {
        return false;
      } else return true;
    },
  },
};
</script>
<style lang="scss">
.add-product {
  .custom-input {
    .v-input__slot {
      width: 100% !important;
    }

    .v-input__control {
      flex-direction: row !important;
    }

    .v-text-field .v-input__control,
    .v-text-field fieldset {
      min-height: 45px !important;
      border-color: #4ba0e7 !important;
    }

    .v-label:not(.v-label--active) {
      transform: translateY(2px);
    }

    .theme--light.v-data-table .v-data-table-header th.sortable:hover {
      color: white !important;
    }

    .theme--light.v-data-table
      > .v-data-table__wrapper
      > table
      > thead
      > tr
      > th {
      color: white !important;
    }

    .v-data-table
      > .v-data-table__wrapper
      tbody
      tr.v-data-table__expanded__content {
      -webkit-box-shadow: none !important;
      box-shadow: none !important;
    }

    .theme--light.v-card > .v-card__subtitle,
    .theme--light.v-card > .v-card__text {
      color: black !important;
    }

    .theme--light.v-data-table {
      background-color: #fff;
      color: black !important;
    }

    table thead {
      color: black !important;
    }

    .custom-table-vue .v-data-table-header tr th {
      text-align: center !important;
      font-size: 15px !important;
      color: black !important;
      height: 50px !important;
    }
  }
}

.color-box {
  direction: ltr;
  display: flex;
  border: none !important;

  .color {
    width: 40px;
    height: 40px;
    // margin-top: 8px;
  }
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  padding: 8px !important;
}

.img-box {
  border-radius: 30px;
  position: relative;
  overflow: hidden;
  width: 170px;
  height: 170px;
  border: none;

  &:hover {
    background-color: #3c03923b !important;

    .img {
      opacity: 0.7;
    }

    .img-icon {
      display: block;
    }
  }

  .img {
    opacity: 1;
    width: 100%;
    height: 100%;
  }

  .img-icon {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: none;
  }

  .img-loading {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background-color: #3c03923b;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
}

.file-input {
  fieldset {
    border-style: dashed !important;
  }
}

.files-box {
  border: 1px solid rgb(172, 172, 172);
  text-align: right;
  font-size: 14px;
  margin-top: 35px;
  padding: 10px;
  border-radius: 7px;
  position: relative;

  ul {
    li {
      text-decoration: none;
    }
  }

  .files-title {
    position: absolute;
    top: -9px;
    right: 20px;
    background-color: #fff;
    font-size: 14px;
    padding: 0 6px;
  }
}
</style>
